/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BasketDiscountCreateRequest } from '../../models/basket-discount-create-request';
import { BasketDiscountCreateResponse } from '../../models/basket-discount-create-response';
import { DiscountCreateResponse } from '../../models/discount-create-response';
import { QuantityDiscountCreateRequest } from '../../models/quantity-discount-create-request';
import { QuantityDiscountCreateResponse } from '../../models/quantity-discount-create-response';
import { SegmentDiscountCreateRequest } from '../../models/segment-discount-create-request';
import { SegmentDiscountCreateResponse } from '../../models/segment-discount-create-response';

export interface CreateOrUpdateDiscounts$Params {
      body: Array<(BasketDiscountCreateRequest | QuantityDiscountCreateRequest | SegmentDiscountCreateRequest)>
}

export function createOrUpdateDiscounts(http: HttpClient, rootUrl: string, params: CreateOrUpdateDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>>> {
  const rb = new RequestBuilder(rootUrl, createOrUpdateDiscounts.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<(DiscountCreateResponse | BasketDiscountCreateResponse | QuantityDiscountCreateResponse | SegmentDiscountCreateResponse)>>;
    })
  );
}

createOrUpdateDiscounts.PATH = '/discounts/bulk';
